<template>
  <Breadcrumbs
      title="Create New User Role"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Users Roles', path: '/user-roles' },
      { label: 'Create New User Role', path: '/new-user-role' },
    ]"
  />
  
  <div class="container-fluid">
    <div class="row project-cards">
      <newUserRoleForm/>
    </div>
  </div>
</template>
  
  
<script>
import newUserRoleForm from './newUserRoleForm.vue';

export default {
  components: {
    newUserRoleForm
  }
}
</script>